import posthog from "posthog-js";
import { shouldInitPostHog } from "./shouldInitPostHog";
import { shouldUseCrossSubdomainCookie } from "./shouldUseCrossSubdomainCookie";

const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

if (shouldInitPostHog(import.meta.env.MODE, key, host)) {
  // E-11 / T1.7: cross_subdomain_cookie → cookie domain `.mivo.digital` on production hosts
  // (mivo.digital / app.mivo.digital). Acceptance is T6.5 smoke, not config alone.
  const crossSubdomainCookie =
    typeof window !== "undefined" && shouldUseCrossSubdomainCookie(window.location.hostname);

  posthog.init(key!, {
    api_host: host!,
    // Never invent a default host (api-contract §1.2) — host is required by the gate.
    cross_subdomain_cookie: crossSubdomainCookie,
    autocapture: false,
    // SPA routes can include patient UUIDs — catalogued events only (BR-14).
    capture_pageview: false,
    capture_pageleave: false,
    capture_exceptions: false,
    disable_session_recording: true,
    disable_surveys: true,
    mask_all_element_attributes: true,
    mask_all_text: true,
    person_profiles: "identified_only",
    persistence: "localStorage+cookie",
    loaded: (instance) => {
      instance.register({
        app_name: "app",
        environment: "production",
      });
    },
  });
}
